<era-panel>

  <div class="p-2">
    <era-pane>
      <ml-async-result [operation]="securityInfo$">
        <div empty>
          <p>No security information available.</p>
        </div>

        @if (securityInfo$ | async; as securityInfo) {
          <div>
            <h5 class="small-caps"
                i18n>Information</h5>
            <table class="table table-sm table-list mb-4">
              <thead>
                <tr>
                  <th colspan="2"
                      scope="col"></th>
                </tr>
              </thead>
              <tbody>
                @if (apple$ | async | os: { iOS: '>=4.0', appleTV: '>=9.0' }) {
                  <tr>
                    <th title="Bitfield. Describes the underlying hardware encryption capabilities of the device. Values are described in Table 10."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Hardware Encryption Caps
                    </th>
                    <td>
                      @if (securityInfo.hardwareEncryptionCaps === 1 || securityInfo.hardwareEncryptionCaps === 3) {
                        <div i18n>
                          Block-level encryption
                        </div>
                      }
                      @if (securityInfo.hardwareEncryptionCaps === 2 || securityInfo.hardwareEncryptionCaps === 3) {
                        <div i18n>
                          File-level encryption
                        </div>
                      }
                    </td>
                  </tr>
                }
                @if (apple$ | async | os: { iOS: '>=4.0', appleTV: '>=9.0' }) {
                  <tr>
                    <th title="Set to true if the device is protected by a passcode."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Passcode Present
                    </th>
                    <td>
                      <ml-yes-no-icon [flag]="securityInfo.passcodePresent"></ml-yes-no-icon>
                    </td>
                  </tr>
                }
                @if (apple$ | async | os: { iOS: '>=4.0', appleTV: '>=9.0' }) {
                  <tr>
                    <th title="Set to true if the user’s passcode is compliant with all requirements on the device, including Exchange and other accounts."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Passcode Compliant
                    </th>
                    <td>
                      <ml-yes-no-icon [flag]="securityInfo.passcodeCompliant"></ml-yes-no-icon>
                    </td>
                  </tr>
                }
                @if (apple$ | async | os: { iOS: '>=4.0', appleTV: '>=9.0' }) {
                  <tr>
                    <th title="Set to true if the user’s passcode is compliant with requirements from profiles."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Passcode Compliant With Profiles
                    </th>
                    <td>
                      <ml-yes-no-icon [flag]="securityInfo.passcodeCompliantWithProfiles"></ml-yes-no-icon>
                    </td>
                  </tr>
                }
                @if (apple$ | async | os: { iOS: '>=4.0', appleTV: '>=9.0' }) {
                  <tr>
                    <th title="The user preference for the amount of time in seconds the device must be locked before unlock will require the device passcode."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Passcode Lock Grace Period
                    </th>
                    <td>{{ securityInfo.passcodeLockGracePeriod }}</td>
                  </tr>
                }
                @if (apple$ | async | os: { iOS: '>=4.0', appleTV: '>=9.0' }) {
                  <tr>
                    <th title="The current enforced value for the amount of time in seconds the device must be locked before unlock will require the device passcode."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Passcode Lock Grace Period Enforced
                    </th>
                    <td>{{ securityInfo.passcodeLockGracePeriodEnforced }}</td>
                  </tr>
                }
                @if (apple$ | async | os: { macOS: '>=10.9' }) {
                  <tr>
                    <th title="Device channel only. Whether Full Disk Encryption (FDE) is enabled or not. Availability: Available in macOS 10.9 and later."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      FDE Enabled
                    </th>
                    <td>
                      <ml-yes-no-icon [flag]="securityInfo.fdE_Enabled"></ml-yes-no-icon>
                    </td>
                  </tr>
                }
                @if (apple$ | async | os: { macOS: '>=10.9' }) {
                  <tr>
                    <th title="Device channel only. If FDE has been enabled, returns whether a personal recovery key has been set. Availability: Available in macOS 10.9 and later."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      FDE Has Personal Recovery Key
                    </th>
                    <td>
                      <ml-yes-no-icon [flag]="securityInfo.fdE_HasPersonalRecoveryKey"></ml-yes-no-icon>
                    </td>
                  </tr>
                }
                @if (apple$ | async | os: { macOS: '>=10.9' }) {
                  <tr>
                    <th title="Device channel only. If FDE has been enabled, returns whether an institutional recovery key has been set.
              Availability: Available in macOS 10.9 and later."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      FDE Has Institutional Recovery Key
                    </th>
                    <td>
                      <ml-yes-no-icon [flag]="securityInfo.fdE_HasInstitutionalRecoveryKey"></ml-yes-no-icon>
                    </td>
                  </tr>
                }
                @if (apple$ | async | os: { macOS: '>=10.13' }) {
                  <tr>
                    <th title="If FileVault Personal Recovery Key (PRK) escrow is enabled and a recovery key has been set up, this key will contain the PRK encrypted with the certificate from the com.securityInfo.security.FDERecoveryKeyEscrow payload and wrapped as a CMS blob. Availability: Available in macOS 10.13 and later."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      FDE Personal Recovery Key CMS
                    </th>
                    <td>{{ securityInfo.fdE_PersonalRecoveryKeyCMS }}</td>
                  </tr>
                }
                @if (apple$ | async | os: { macOS: '>=10.13' }) {
                  <tr>
                    <th title="If FileVault PRK escrow is enabled and a recovery key has been set up, this key contains a short string that is displayed to the user in the EFI login window as part of the help message if the user enters an incorrect password three times. The server can use this string as an index when saving the device PRK. Currently, this string is the device serial number, which replaces the recordNumber that was returned by the server in the earlier escrow mechanism. Availability: Available in macOS 10.13 and later."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      FDE Personal Recovery Key Device Key
                    </th>
                    <td>{{ securityInfo.fdE_PersonalRecoveryKeyDeviceKey }}</td>
                  </tr>
                }
                @if (apple$ | async | os: { macOS: '>=10.12' }) {
                  <tr>
                    <th title="Device channel only. Whether System Integrity Protection is enabled on the device. In macOS 10.11 or later, this information may also be retrieved using a DeviceInformation query. Availability: Available in macOS 10.12 and later."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      System Integrity Protection Enabled
                    </th>
                    <td>
                      <ml-yes-no-icon [flag]="securityInfo.systemIntegrityProtectionEnabled"></ml-yes-no-icon>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            @if (apple$ | async | os: { macOS: '>=10.12' }) {
              <h5 class="small-caps"
                  i18n>Firewall Settings</h5>
            }
            @if (securityInfo.firewallSettings && apple$ | async | os: { macOS: '>=10.12' }) {
              <table class="table table-sm table-list mb-4">
                <thead>
                  <tr>
                    <th colspan="2"
                        scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th title="Whether firewall is on or off."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Firewall Enabled
                    </th>
                    <td>{{ securityInfo.firewallSettings?.firewallEnabled }}</td>
                  </tr>
                  <tr>
                    <th title="Whether all incoming connections are blocked."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Block All Incoming
                    </th>
                    <td>{{ securityInfo.firewallSettings?.blockAllIncoming }}</td>
                  </tr>
                  <tr>
                    <th title="Whether stealth mode is enabled."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Stealth Mode
                    </th>
                    <td>{{ securityInfo.firewallSettings?.stealthMode }}</td>
                  </tr>
                  <tr>
                    <th colspan="2"
                        title="Blocking status for specific applications. "
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Applications
                    </th>
                  </tr>
                  <tr>
                    <td colspan="2">
                      @if (securityInfo.firewallSettings?.applications) {
                        <table class="table table-sm">
                          <thead>
                            <tr>
                              <th colspan="2"
                                  scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (application of securityInfo.firewallSettings?.applications; track application) {
                              <tr>
                                <td>{{ application.bundleID }}</td>
                                <td>{{ application.allowed }}</td>
                                <td>{{ application.name }}</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            }
            @if (!securityInfo.firewallSettings && (apple$ | async | os: { macOS: '>=10.12' })) {
              <p class="mb-4">
                No firewall settings information available.
              </p>
            }
            @if (apple$ | async | os: { macOS: '>=10.12' }) {
              <h5 class="small-caps"
                  i18n>Firmware Password Status</h5>
            }
            @if (securityInfo.firmwarePasswordStatus && apple$ | async | os: { macOS: '>=10.12' }) {
              <table class="table table-sm table-list mb-4">
                <thead>
                  <tr>
                    <th colspan="2"
                        scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th title="Whether an EFI firmware password is set or not."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Password Exists
                    </th>
                    <td>{{ securityInfo.firmwarePasswordStatus?.passwordExists }}</td>
                  </tr>
                  <tr>
                    <th title="If true, a firmware password change is pending and the device requires rebooting; attempts to set, change, or delete the password will fail."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Change Pending
                    </th>
                    <td>{{ securityInfo.firmwarePasswordStatus?.changePending }}</td>
                  </tr>
                  <tr>
                    <th title="Whether or not option ROMs are enabled."
                        data-toggle="tooltip"
                        data-placement="right"
                        scope="row">
                      Allow Oroms
                    </th>
                    <td>{{ securityInfo.firmwarePasswordStatus?.allowOroms }}</td>
                  </tr>
                </tbody>
              </table>
            }
            @if (!securityInfo.firmwarePasswordStatus && (apple$ | async | os: { macOS: '>=10.12' })) {
              <p class="mb-4">
                No password status available.
              </p>
            }
          </div>
        }
      </ml-async-result>
    </era-pane>
  </div>
  <era-panel-footer>
    <div class="btn-toolbar p-1 bg-gray-100 border-top">
      @if (udid() !== undefined) {
        <ml-mdm-command-spinner [commandProgress]="commandProgress$"
                                [small]="true"
                                [direction]="'right'"
                                [reverse]="true"
                                class="flex-grow-1 text-end">
          <button type="button"
                  (click)="refresh()"
                  [class]="'btn btn-outline-primary border-0'">
            <fa-icon icon="sync"></fa-icon>
          </button>
        </ml-mdm-command-spinner>
      }
    </div>
  </era-panel-footer>
</era-panel>